// API configuration
export const API_CONFIG = {
  BASE_URL: 'https://api.x.ai/v1',
  ENDPOINTS: {
    CHAT: '/chat/completions'
  },
  MODEL: 'grok-beta',
  TEMPERATURE: 0.7,
  SYSTEM_PROMPT: 'Eres un chef experto con amplia experiencia en cocina española y mediterránea. Proporcionas instrucciones detalladas y profesionales, adaptándote al nivel de experiencia del cocinero y los equipos disponibles.'
};